import { useQuery } from '@tanstack/react-query';
import { api } from '../api';
import { historyText, PEOPLE_GRID_KEY, shortDate, type HistoryEntry } from './peopleGrid';

/** „Historia” of the cell menu (stage 1b I): what was done with the person on that day, by whom and when. */
export function CellHistory({ personId, personName, day, onClose }: { personId: string; personName: string; day: string; onClose: () => void }) {
  const history = useQuery({
    queryKey: [...PEOPLE_GRID_KEY, 'history', personId, day],
    queryFn: () => api<{ entries: HistoryEntry[] }>(`/api/crew/people-availability/history?personId=${personId}&day=${day}`),
  });
  return (
    <section className="pg-details" aria-label={`Historia: ${personName}, ${shortDate(day)}`} data-feature-id="crew.people_availability">
      <div className="pg-details-head">
        <h3>
          Historia: {personName}, {shortDate(day)}
        </h3>
        <button className="btn ghost small" type="button" onClick={onClose}>
          Zamknij
        </button>
      </div>
      {history.isLoading && <p className="muted">Wczytywanie…</p>}
      {history.data && history.data.entries.length === 0 && <p className="muted">Nic jeszcze nie zrobiono w tym dniu.</p>}
      {history.data && history.data.entries.length > 0 && (
        <ol className="pg-history">
          {history.data.entries.map((e, i) => (
            <li key={i}>{historyText(e)}</li>
          ))}
        </ol>
      )}
    </section>
  );
}
